




























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import EditorWithFile from "@/components/EditorWithFile.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { getCurrentCompanyId } from "@/plugins/roles";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import LearningResourceTable from "@/components/contract/LearningResourceTable.vue";
import { LearningGroup as ILearningGroup } from "@/api-v2/learning-group/models/learning-group";
import { LearningGroupCreate as ILearningGroupCreate } from "@/api-v2/learning-group/models/learning-group-create";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import LearningGroupStudentTable from "@/components/learning-group/LearningGroupStudentTable.vue";
import LearningGroupAddStudentsTable from "@/components/learning-group/LearningGroupAddStudentsTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: {
    CustomButton,
    LearningGroupAddStudentsTable,
    LearningGroupStudentTable,
    CPageButtons,
    LearningResourceTable,
    CSingleSelect,
    EditorWithFile,
    CBlock,
    CField
  }
})
export default class CourseFormV2 extends Vue {
  @Prop() group!: ILearningGroup;
  @Prop({ default: false }) isLoading!: boolean;
  course: any = {};
  students: any = [];
  isShowAddStudents: boolean = false;
  form: ILearningGroupCreate = {
    title: "",
    description: "",
    responsibleId: "",
    registrationsIds: [] as string[],
    courseId: ""
  };
  employees: EmployeesListClass = new EmployeesListClass(
    {
      id: this.selectedCompany,
      limit: 900
    },
    this.selectedCompany,
    this.group?.responsibleId ??
      undefined ??
      (this.$route.query.responsibleId
        ? this.$route.query.responsibleId
        : undefined)
  );

  coursesList: CoursesListClass = new CoursesListClass(
    { mode: "v2" },
    this.group?.courseId ??
      undefined ??
      (this.$route.query.courseId ? this.$route.query.courseId : undefined)
  );

  getStudents(items: Array<any>) {
    this.form.registrationsIds = items.map(el => el.id);
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  async create() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.group) {
      this.form.registrationsIds = [
        ...(this.form.registrationsIds as string[]),
        ...this.group.registrations.map(({ id }) => id)
      ];
    }
    this.$emit("submit", this.form);
  }
  remove() {
    this.$emit("remove");
  }

  cancel() {
    this.$emit("cancel");
  }

  created() {
    if (this.group) {
      this.form = { ...this.group };
    }
    if (this.$route.query.courseId) {
      this.form.courseId = this.$route.query.courseId as string;
    }
    if (this.$route.query.responsibleId) {
      this.form.responsibleId = this.$route.query.responsibleId as string;
    }
  }
}
